/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { LogoResource } from './';
import {
    LogoResourceFromJSON,
    LogoResourceFromJSONTyped,
    LogoResourceToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { RecommendationResource } from './';
import {
    RecommendationResourceFromJSON,
    RecommendationResourceFromJSONTyped,
    RecommendationResourceToJSON,
} from './';
import type { RequestOrigin } from './';
import {
    RequestOriginFromJSON,
    RequestOriginFromJSONTyped,
    RequestOriginToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExperienceRequest
 */
export interface ExperienceRequest {
    /**
     * 
     * @type {string}
     * @memberof ExperienceRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceRequest
     */
    company: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceRequest
     */
    organizationName?: string;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ExperienceRequest
     */
    area?: ActivityArea;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceRequest
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ExperienceRequest
     */
    currentJob?: boolean;
    /**
     * 
     * @type {PostalAddress}
     * @memberof ExperienceRequest
     */
    location?: PostalAddress;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExperienceRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof ExperienceRequest
     */
    skills?: Array<Skill>;
    /**
     * 
     * @type {Array<RecommendationResource>}
     * @memberof ExperienceRequest
     */
    recos?: Array<RecommendationResource>;
    /**
     * 
     * @type {boolean}
     * @memberof ExperienceRequest
     */
    asFreelance?: boolean;
    /**
     * 
     * @type {LogoResource}
     * @memberof ExperienceRequest
     */
    logo?: LogoResource;
    /**
     * 
     * @type {RequestOrigin}
     * @memberof ExperienceRequest
     */
    requestOrigin?: RequestOrigin;
}

/**
 * Check if a given object implements the ExperienceRequest interface.
 */
export function instanceOfExperienceRequest(value: object): value is ExperienceRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function ExperienceRequestFromJSON(json: any): ExperienceRequest {
    return ExperienceRequestFromJSONTyped(json, false);
}

export function ExperienceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'title': json['title'],
        'company': json['company'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'area': json['area'] == null ? undefined : ActivityAreaFromJSON(json['area']),
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'currentJob': json['currentJob'] == null ? undefined : json['currentJob'],
        'location': json['location'] == null ? undefined : PostalAddressFromJSON(json['location']),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'skills': json['skills'] == null ? undefined : ((json['skills'] as Array<any>).map(SkillFromJSON)),
        'recos': json['recos'] == null ? undefined : ((json['recos'] as Array<any>).map(RecommendationResourceFromJSON)),
        'asFreelance': json['asFreelance'] == null ? undefined : json['asFreelance'],
        'logo': json['logo'] == null ? undefined : LogoResourceFromJSON(json['logo']),
        'requestOrigin': json['requestOrigin'] == null ? undefined : RequestOriginFromJSON(json['requestOrigin']),
    };
}

export function ExperienceRequestToJSON(value?: ExperienceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'description': value['description'],
        'title': value['title'],
        'company': value['company'],
        'companyId': value['companyId'],
        'organizationName': value['organizationName'],
        'area': ActivityAreaToJSON(value['area']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'currentJob': value['currentJob'],
        'location': PostalAddressToJSON(value['location']),
        'tags': value['tags'],
        'skills': value['skills'] == null ? undefined : ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
        'recos': value['recos'] == null ? undefined : ((value['recos'] as Array<any>).map((v) => RecommendationResourceToJSON(v))),
        'asFreelance': value['asFreelance'],
        'logo': LogoResourceToJSON(value['logo']),
        'requestOrigin': RequestOriginToJSON(value['requestOrigin']),
    };
}

